module.exports = __webpack_public_path__ + "static/media/bolivia_cile_dove_1.5f1f88b4.jpg";